// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo[data-v-cef48b66]{width:50px;height:50px;border-radius:50px;overflow:hidden}.gzBtn[data-v-cef48b66]{background:red;border-radius:50px;color:#fff;width:%?130?%;display:inline-block;text-align:center;height:28px;line-height:28px}.btn2[data-v-cef48b66]{background:#c2c2c2}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
